<template>
    <div class="login-bg" :style="'background-image:url(' + bgimg_url + ');'">
        <div class="login-title">
            <img :src="supplier_logo" alt="">
            <span>{{ supplier_name }}</span>
        </div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-position="left" label-width="0px" class="demo-ruleForm login-container">
            <h2 class="title" style="margin-bottom: 20px;">考生登录</h2>
            <!--手机号-->
            <el-form-item prop="account">
                <el-input type="text" maxlength="11" prefix-icon="el-icon-user-solid" v-model="ruleForm.account" auto-complete="off" placeholder="手机号" />
            </el-form-item>
            <!--密码-->
            <el-form-item prop="checkPass">
                <el-input type="password" prefix-icon="el-icon-lock" v-model="ruleForm.checkPass" auto-complete="off" placeholder="密码" show-password />
            </el-form-item>
            <!--登录-->
            <el-form-item>
                <el-button type="primary" style="width:100%;" @click.native.prevent="SubmitFunc" :loading="logining">
                    登录
                </el-button>
            </el-form-item>

            <div class="logon-register">
                <div class="register">没有账号？<el-link :underline="false"style="color: #376ef0"@click.native.prevent="register">去注册</el-link></div>
                <div class="forget" @click="restpwd">忘记密码</div>
            </div>
        </el-form>
    </div>
</template>

<script>
    import IndexApi from '@/api/index.js';
    import bgimg from '@/assets/img/login_bg.png';
    import UserApi from '@/api/user.js';
    import { setCookie, setSessionStorage } from '@/utils/base.js';

    export default {
        data() {
            return {
                // 是否正在加载
                loading: true,
                // 系统名称
                supplier_name: '',
                // 系统logo
                supplier_logo: '',
                // 背景图片
                bgimg_url: '',
                // 是否正在提交
                logining: false,
                // 表单对象
                ruleForm: {
                    // 用户名
                    account: '',
                    // 密码
                    checkPass: ''
                },
                // 验证规则
                rules: {
                    // 用户名
                    account: [{required: true, message: '请输入用户名', trigger: 'blur'}],
                    // 密码
                    checkPass: [{required: true, message: '请输入密码', trigger: 'blur'}]
                },
                // 基础配置
                baseData: {}
            };
        },
        created() {
            this.getData();
        },
        methods: {
            // 获取基础配置
            getData() {
                let self = this;
                IndexApi.base(true)
                    .then(res => {
                        self.loading = false;
                        self.baseData = res.data;
                        self.supplier_logo = res.data.settings.supplier_logo;
                        self.supplier_name = res.data.settings.supplier_name;
                        if (res.data.settings.supplier_bg_img != '') {
                            self.bgimg_url = res.data.settings.supplier_bg_img;
                        } else {
                            self.bgimg_url = bgimg;
                        }
                    })
                    .catch(error => {
                        self.loading = false;
                    });
            },

            // 登录
            SubmitFunc(ev) {
                var that = this;
                that.$refs.ruleForm.validate(valid => {
                    if (valid) {
                        that.logining = true;
                        var Params = {
                            username: that.ruleForm.account,
                            password: that.ruleForm.checkPass
                        };
                        // 调用登录接口
                        UserApi.login(Params, true)
                            .then(res => {
                                that.logining = false;
                                if (res.code == 1) {
                                    // 保存个人信息
                                    setCookie('userinfo_supplier', res.data);
                                    // 设置一个登录状态
                                    setCookie('isLogin_supplier', true);
                                    // 保存token
                                    setCookie('token_supplier', res.data.token);
                                    // 跳转到首页
                                    that.logining = false;
                                    that.$router.push({path: "/"});
                                } else {
                                    that.$message({
                                        message: '登录失败',
                                        type: 'error'
                                    });
                                }
                            })
                            .catch(error => {
                                // 接口调用方法统一处理
                                that.logining = false;
                            });
                    }
                });
            },

            // 去注册
            register() {
                this.$router.push({path: "/register"});
            },
            restpwd() {
                this.$router.push({path: "/resetpassword"});
            },
        }
    };
</script>

<style lang="scss" scoped>
    .login-bg {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-repeat: no-repeat;
        background-position: center;
        background-size: 100%;
        .login-title{
            width: 100%;
            height: 75px;
            background-color: #409EFF;
            display: flex;
            justify-content: center;
            align-items: center;
            img{
                width: 40px;
                height: 40px;
            }
            span{
                margin-left: 10px;
                font-size: 28px;
                font-weight: bold;
                color: #fff;
            }
        }
        .logon-register{
            display: flex;
            justify-content: space-between;
            align-items: center;
            .register{
                cursor: pointer;
            }
            .forget{
                cursor: pointer;
            }
        }
    }

    .login-container {
        box-shadow: 0px 0px 2px 2px #66666640;
        -webkit-border-radius: 5px;
        border-radius: 5px;
        -moz-border-radius: 5px;
        background-clip: padding-box;
        position: fixed;
        width: 450px;
        left: 50%;
        top: 50%;
        margin-left: -175px;
        margin-top: -175px;
        padding: 35px;
        background: #fff;
        border: 1px solid #eaeaea;

        .title {
            margin: 0px auto 40px auto;
            text-align: center;
            color: #505458;
        }

        .remember {
            margin: 0px 0px 35px 0px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/login.vue